var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSims(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1296_2329",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1296_2329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.11299 20.8872C5.22598 22.0002 7.0173 22.0002 10.6 22.0002C14.1826 22.0002 15.974 22.0002 17.0869 20.8872C18.1999 19.7743 18.1999 17.9829 18.1999 14.4002C18.1999 13.4261 17.8099 12.4943 17.1211 11.8054L13.1948 7.87906C12.5059 7.19025 11.5741 6.80029 10.6 6.80029C7.0173 6.80029 5.22598 6.80029 4.11299 7.91328C3 9.02627 3 10.8176 3 14.4002C3 17.9829 3 19.7743 4.11299 20.8872Z",
    stroke: "#C0C2C9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2 18.1035C19.4351 17.982 20.2665 17.7074 20.887 17.0869C22 15.974 22 14.1826 22 10.6C22 9.62583 21.61 8.69397 20.9212 8.00516L16.9948 4.07877C16.306 3.38995 15.3742 3 14.4001 3C10.8173 3 9.02605 3 7.91305 4.11299C7.29254 4.7335 7.01797 5.56488 6.89648 6.79998",
    stroke: "#C0C2C9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6 14.3994H9.64999C8.75432 14.3994 8.3065 14.3994 8.02824 14.6777C7.75 14.9559 7.75 15.4037 7.75 16.2994V17.2494C7.75 18.1451 7.75 18.5929 8.02824 18.8711C8.3065 19.1494 8.75432 19.1494 9.64999 19.1494H10.6M10.6 14.3994H11.55C12.4456 14.3994 12.8935 14.3994 13.1717 14.6777C13.45 14.9559 13.45 15.4037 13.45 16.2994V16.7744M10.6 14.3994V16.7744M10.6 19.1494H11.55C12.4456 19.1494 12.8935 19.1494 13.1717 18.8711C13.45 18.5929 13.45 18.1451 13.45 17.2494V16.7744M10.6 19.1494V16.7744M13.45 16.7744H10.6",
    stroke: "#C0C2C9",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSims);
export default __webpack_public_path__ + "static/media/Sims.3b6852ad5621cb8119d6501519a582e9.svg";
export { ForwardRef as ReactComponent };